import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import { IStoreRedux } from 'Types/Reducers';
import { primeiraMaiusculaTodasPalavras } from '../../../_recursos/js/util';

function ComoConheceu() {
  const valor = useSelector<IStoreRedux, string>(state => state.dados.como_conheceu || '');
  const valorDetalhes = useSelector<IStoreRedux, string>(state => state.dados.como_conheceu_detalhes || '');
  const dispatch = useDispatch()
  const [validoDetalhes, setValidoDetalhes] = useState<boolean | null>(null);

  useEffect(() => void dispatch({ type: 'ALTERA_ETAPA_ATUAL', etapaAtual: 'como_conheceu' }), [dispatch]);

  // Valida etapa quando valor ou valorDetalhes mudarem
  useEffect(() => {
    validaEtapa(valor, valorDetalhes);
  }, [valor, valorDetalhes]);

  const aoAlterar = useCallback((e) => {
    const novoValor = e.target.value;
    dispatch({ type: 'ALTERA_COMO_CONHECEU', como_conheceu: novoValor });

    // Limpa os detalhes se mudar para uma opção que não requer detalhes
    if (novoValor !== "Amigo ou Familiar" && novoValor !== "Outro") {
      dispatch({ type: 'ALTERA_COMO_CONHECEU_DETALHES', como_conheceu_detalhes: '' });
      setValidoDetalhes(null);
    }
  }, [dispatch]);

  const aoAlterarDetalhes = useCallback((e) => {
    let valorAlterado = e.target.value;

    // Se for "Amigo ou Familiar", aplica formatação de nome
    if (valor === "Amigo ou Familiar") {
      valorAlterado = primeiraMaiusculaTodasPalavras(valorAlterado);
    }

    dispatch({ type: 'ALTERA_COMO_CONHECEU_DETALHES', como_conheceu_detalhes: valorAlterado });
    validaDetalhes(valorAlterado);
  }, [dispatch, valor]);

  function validaDetalhes(valorDetalhes: string) {
    if (valor === "Amigo ou Familiar") {
      // Valida com regex de nome completo
      const regex = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]{2,}\s([A-Za-z\s]{2,3})?[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ\s']{4,}$/;
      const resultado = regex.test(valorDetalhes);
      setValidoDetalhes(resultado);
      return resultado;
    } else if (valor === "Outro") {
      // Valida apenas se não está vazio
      const resultado = valorDetalhes.trim().length > 0;
      setValidoDetalhes(resultado);
      return resultado;
    }
    return true;
  }

  function validaEtapa(valorPrincipal: string, valorDetalhes: string) {
    // Se não selecionou nada, etapa inválida
    if (!valorPrincipal) {
      dispatch({ type: `VALIDA_ETAPA`, etapaValida: false });
      return;
    }

    // Se selecionou opção que requer detalhes
    if (valorPrincipal === "Amigo ou Familiar" || valorPrincipal === "Outro") {
      const detalhesValido = validaDetalhes(valorDetalhes);
      dispatch({ type: `VALIDA_ETAPA`, etapaValida: detalhesValido });
    } else {
      // Opções que não requerem detalhes são válidas imediatamente
      dispatch({ type: `VALIDA_ETAPA`, etapaValida: true });
    }
  }

  // Verifica se deve mostrar o campo de detalhes
  const mostraDetalhes = valor === "Amigo ou Familiar" || valor === "Outro";

  // Label dinâmico baseado na seleção
  const labelDetalhes = valor === "Amigo ou Familiar"
    ? "Nome do Amigo/Familiar"
    : "Especifique";

  return (
    <div className="etapa-formulario">
      <TextField
        select
        fullWidth
        label="Como nos conheceu?"
        value={valor}
        onChange={aoAlterar}
      >
        <MenuItem value="Google">Google</MenuItem>
        <MenuItem value="Instagram">Instagram</MenuItem>
        <MenuItem value="Facebook">Facebook</MenuItem>
        <MenuItem value="Youtube">Youtube</MenuItem>
        <MenuItem value="Amigo ou Familiar">Amigo ou Familiar</MenuItem>
        <MenuItem value="Outro">Outro</MenuItem>
      </TextField>

      {mostraDetalhes && (
        <TextField
          fullWidth
          label={labelDetalhes}
          value={valorDetalhes}
          onInput={aoAlterarDetalhes}
          error={validoDetalhes !== null && !validoDetalhes}
          autoComplete="off"
          style={{ marginTop: '16px' }}
        />
      )}
    </div>
  )
}

export default ComoConheceu